import React from "react"
import clsx from "clsx"
import { Form } from "react-bootstrap"

import CurrencyInputWrapper from "./CurrencyInputWrapper"
import classes from "./CurrencyInput.module.scss"

const CurrencyInput = props => {
  const {
    value,
    onChange,
    error,
    label,
    placeholder,
    disabled = false,
    className,
    inputClassName
  } = props

  const handleValueChange = (value, name, values) => {
    onChange(values.float)
  }

  return (
    <div className={className}>
      {
        !!label &&
        <div className={classes["row"]}>
          <label className={classes["label"]}>
            {label}
          </label>
        </div>
      }
      <CurrencyInputWrapper
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete="off"
        className={clsx(!!error && classes["input-error"])}
        customInput={Form.Control}
        inputClassName={inputClassName}
        allowDecimals={false}
        onValueChange={handleValueChange}
        groupSeparator=","
      />
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default CurrencyInput